module.exports = __webpack_public_path__ + "static/media/success.ff614af7.svg";